/* KAARKASH editorial product page (sections/main-product, pdp_style "editorial"; look in
   assets/kk-product.css).
   - The column beside the photographs stays in view. When it is taller than the window, it
     is held by its foot instead of its head, so everything in it can still be reached.
   - The details (Description, Wash & Care, Shipping & Returns, FAQs). On a wide screen a
     link opens one in place of the column, and its dash brings the column back. On a phone,
     "All details" opens a sheet over the page with a tab for each. It is a dialog then: the
     page behind stays put, Tab stays inside, Escape or × closes it, and the press that
     opened it gets the focus back.
   - Reviews: the product-reviews section is moved into the Reviews detail (the stars under
     the price open it too); with no reviews section on the page, there is no such detail.
   - The Description is set as the other details are: a paragraph that is only a short bold
     line becomes a heading in small capitals, as the reference's are; a paragraph wholly in
     bold reads as the others do; sizes and colours pasted in with it are let go (the CSS).
   - Add to cart, as the reference's (assets/kk-product.css): a slanted sweep and a running
     line while it goes, then the cart drawer. Refused: the button shakes.
   - More for you (sections/kk-product-more): the cards the server chose, or the ones Dawn's
     product-recommendations puts in when it chose none, have their photographs made to swipe.
   Dawn's own scripts are left to do everything else. */
(function () {
  'use strict';
  if (window.__kkProduct) return;
  window.__kkProduct = true;

  var wide = window.matchMedia('(min-width: 990px)');      // the details open in place
  var twoCol = window.matchMedia('(min-width: 750px)');    // photographs beside the column
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var SHEET_MS = 500;

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  function onMedia(mq, fn, signal) {
    if (mq.addEventListener) mq.addEventListener('change', fn, { signal: signal });
    else if (mq.addListener) { mq.addListener(fn); signal.addEventListener('abort', function () { mq.removeListener(fn); }); }
  }

  /* ---------- the column that stays in view ---------- */
  function holdColumn(info, signal) {
    var queued = false;
    function fit() {
      queued = false;
      if (!twoCol.matches) { info.style.removeProperty('--kkp-top'); return; }
      var over = info.offsetHeight - window.innerHeight;
      info.style.setProperty('--kkp-top', over > 0 ? -over + 'px' : '0px');
    }
    function queue() { if (!queued) { queued = true; requestAnimationFrame(fit); } }
    fit();
    window.addEventListener('resize', queue, { signal: signal });
    onMedia(twoCol, queue, signal);
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(queue);
      ro.observe(info);
      signal.addEventListener('abort', function () { ro.disconnect(); });
    }
    return queue;
  }

  /* ---------- the details ---------- */
  function details(root, info, refit, signal) {
    var read = root.querySelector('[data-kkp-read]');
    if (!read) return;
    var home = read.parentNode;
    var panels = read.querySelectorAll('[data-kkp-panel]');
    var tabs = read.querySelectorAll('[data-kkp-tab]');
    var openers = root.querySelectorAll('[data-kkp-open]');
    var current = null, mode = null, opener = null, hideTimer = 0;

    function show(n) {
      current = String(n);
      each(panels, function (p) { p.hidden = p.getAttribute('data-kkp-panel') !== current; });
      each(tabs, function (t) {
        var on = t.getAttribute('data-kkp-tab') === current;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on && t.scrollIntoView && mode === 'sheet') t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      });
      var scroller = read.querySelector('.kkp-read__panels');
      if (scroller) scroller.scrollTop = 0;
      each(openers, function (b) {
        var mine = mode === 'sheet' ? b.classList.contains('kkp-more__all') || b === opener : b.getAttribute('data-kkp-open') === current;
        b.setAttribute('aria-expanded', mode && mine ? 'true' : 'false');
      });
    }
    function panel() { return read.querySelector('[data-kkp-panel="' + current + '"]'); }

    function open(n, from) {
      clearTimeout(hideTimer);
      opener = from || null;
      if (wide.matches) {
        mode = 'inline';
        if (read.parentNode !== home) home.appendChild(read);
        read.classList.remove('is-open');
        read.removeAttribute('role');
        read.removeAttribute('aria-modal');
        read.hidden = false;
        info.classList.add('is-reading');
        show(n);
        refit();
        var p = panel();
        if (p) p.focus({ preventScroll: true });
        // the column may have been held by its foot, above the window: bring its head in
        var top = info.getBoundingClientRect().top;
        if (top < 0) window.scrollBy({ top: top - 16, behavior: reduced.matches ? 'auto' : 'smooth' });
      } else {
        mode = 'sheet';
        if (read.parentNode !== document.body) document.body.appendChild(read);
        read.setAttribute('role', 'dialog');
        read.setAttribute('aria-modal', 'true');
        read.hidden = false;
        show(n);
        document.documentElement.classList.add('kkp-locked');
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            if (mode !== 'sheet') return;
            read.classList.add('is-open');
            // only now can it take the focus: until is-open it is visibility:hidden
            var tab = read.querySelector('[data-kkp-tab][aria-selected="true"]');
            (tab || read.querySelector('[data-kkp-close]')).focus({ preventScroll: true });
          });
        });
      }
    }

    function close(instant) {
      if (!mode) return;
      var was = mode;
      mode = null;
      each(openers, function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (was === 'inline') {
        read.hidden = true;
        info.classList.remove('is-reading');
        refit();
      } else {
        read.classList.remove('is-open');
        document.documentElement.classList.remove('kkp-locked');
        var done = function () {
          read.hidden = true;
          if (read.parentNode !== home) home.appendChild(read);
        };
        if (instant || reduced.matches) done();
        else hideTimer = setTimeout(done, SHEET_MS);
      }
      if (opener && document.body.contains(opener)) opener.focus({ preventScroll: was === 'sheet' });
      opener = null;
    }

    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-kkp-open]');
      if (!b || !root.contains(b)) return;
      var n = b.getAttribute('data-kkp-open');
      if (mode === 'inline' && current === n) { close(); return; }
      open(n, b);
    }, { signal: signal });
    read.addEventListener('click', function (e) {
      if (e.target.closest('[data-kkp-close]')) { close(); return; }
      var t = e.target.closest('[data-kkp-tab]');
      if (t) show(t.getAttribute('data-kkp-tab'));
    }, { signal: signal });
    // Escape closes whatever is open, wherever the focus is
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mode) { e.preventDefault(); close(); }
    }, { signal: signal });
    read.addEventListener('keydown', function (e) {
      var t = e.target.closest('[data-kkp-tab]');
      if (t && (e.key === 'ArrowRight' || e.key === 'ArrowLeft' || e.key === 'Home' || e.key === 'End')) {
        var list = Array.prototype.slice.call(tabs);
        var i = list.indexOf(t);
        if (e.key === 'ArrowRight') i = (i + 1) % list.length;
        else if (e.key === 'ArrowLeft') i = (i - 1 + list.length) % list.length;
        else if (e.key === 'Home') i = 0;
        else i = list.length - 1;
        e.preventDefault();
        show(list[i].getAttribute('data-kkp-tab'));
        list[i].focus();
        return;
      }
      if (e.key === 'Tab' && mode === 'sheet') {
        // what Tab can reach: the tabs not chosen are reached with the arrow keys instead
        var focusable = Array.prototype.filter.call(
          read.querySelectorAll('button, [href], input, select, textarea, [tabindex]'),
          function (el) { return el.getAttribute('tabindex') !== '-1' && !el.disabled && el.getClientRects().length > 0; }
        );
        if (!focusable.length) return;
        var first = focusable[0], last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }, { signal: signal });
    // a window turned or resized from one layout to the other closes what was open
    onMedia(wide, function () { close(true); }, signal);

    // the theme editor: a detail chosen in the sidebar is shown
    document.addEventListener('shopify:block:select', function (e) {
      var p = e.target && e.target.closest && e.target.closest('[data-kkp-panel]');
      if (p && read.contains(p)) open(p.getAttribute('data-kkp-panel'));
    }, { signal: signal });
    document.addEventListener('shopify:block:deselect', function (e) {
      if (e.target && read.contains(e.target)) close(true);
    }, { signal: signal });
    // the section taken away (theme editor): nothing of the sheet is left over the page
    signal.addEventListener('abort', function () {
      clearTimeout(hideTimer);
      document.documentElement.classList.remove('kkp-locked');
      if (read.parentNode === document.body) read.remove();
    });
  }

  /* ---------- Add to cart: refused, it shakes ----------
     The rest is the reference's and CSS's: the sweep and the running line while it goes
     (Dawn's .loading), then Dawn opens the cart drawer. Heard from Dawn's own pub-sub, only for
     this product's form: a quick add elsewhere on the page publishes the same event. */
  function bagButton(root, signal) {
    // Dawn's names are a top-level const (assets/constants.js): a global, but not on window
    var EVENTS = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : null;
    if (typeof window.subscribe !== 'function' || !EVENTS) return;
    var off = window.subscribe(EVENTS.cartError, function (ev) {
      var btn = root.querySelector('[id^="ProductSubmitButton-"]');
      var id = root.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
      if (!ev || ev.source !== 'product-form' || !btn || !id || String(ev.productVariantId) !== String(id.value)) return;
      btn.classList.remove('is-shake'); void btn.offsetWidth; btn.classList.add('is-shake');
      setTimeout(function () { btn.classList.remove('is-shake'); }, 450);
    });
    signal.addEventListener('abort', function () { if (typeof off === 'function') off(); });
  }

  /* ---------- reviews, in their detail ---------- */
  function placeReviews(root) {
    var slot = root.querySelector('[data-kkp-reviews-slot]');
    if (!slot) return;
    var reviews = document.querySelector('[data-product-reviews]');
    if (reviews) { slot.appendChild(reviews); return; }
    each(root.querySelectorAll('[data-kkp-open="reviews"], [data-kkp-tab="reviews"], [data-kkp-panel="reviews"]'), function (el) { el.remove(); });
  }

  /* ---------- the Description, set as the others ---------- */
  function tidy(root) {
    each(root.querySelectorAll('[data-kkp-tidy] p'), function (p) {
      if (p.querySelector('img, picture, video, iframe, svg, table')) return;   // a size chart, a film
      var text = p.textContent.replace(/\s+/g, ' ').trim();
      if (!text) { p.remove(); return; }
      var bold = Array.prototype.map.call(p.querySelectorAll('b, strong'), function (b) { return b.textContent; })
        .join('').replace(/\s+/g, ' ').trim();
      if (bold !== text) return;
      p.classList.add(text.length <= 48 ? 'kkp-h' : 'kkp-plain');
    });
  }

  function setup(root) {
    if (root.__kkp) return;
    var info = root.querySelector('.product__info-container');
    if (!info) return;
    // everything this page adds is taken away with its section (the theme editor re-draws it)
    var ctl = window.AbortController ? new AbortController() : null;
    var signal = ctl ? ctl.signal : { addEventListener: function () {} };
    root.__kkp = ctl || true;
    placeReviews(root);
    tidy(root);
    bagButton(root, signal);
    details(root, info, holdColumn(info, signal), signal);
  }
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target && e.target.querySelector && e.target.querySelector('product-info.kkp');
    if (root && root.__kkp && root.__kkp.abort) root.__kkp.abort();
  });

  /* ---------- More for you ---------- */
  function recommendations(sec) {
    if (sec.__kkp) return;
    sec.__kkp = true;
    // the pieces chosen by the server (div.kkp-recs), or Shopify's list when there are none
    var holder = sec.querySelector('.kkp-recs');
    if (!holder) return;
    function ready() {
      if (!holder.querySelector('.kkc-card')) return false;
      sec.hidden = false;
      if (window.__initCardSwipe) window.__initCardSwipe(holder);
      return true;
    }
    // the server's pieces may be there already; Shopify's own list can replace them later,
    // and its cards need their swipe too
    ready();
    if (!window.MutationObserver) return;
    new MutationObserver(ready).observe(holder, { childList: true });
  }

  function init() {
    each(document.querySelectorAll('product-info.kkp'), setup);
    each(document.querySelectorAll('[data-kkp-recs]'), recommendations);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function (e) {
    init();
    // the reviews section re-drawn by the theme editor lands where it stands in the template
    if (e.target && e.target.querySelector && e.target.querySelector('[data-product-reviews]')) {
      each(document.querySelectorAll('product-info.kkp [data-kkp-reviews-slot]'), function (slot) {
        if (!slot.firstElementChild) slot.appendChild(e.target.querySelector('[data-product-reviews]'));
      });
    }
  });
})();
